@import "../../../../../shared/styles/base";

.filter-chips {
  display: flex;
  user-select: none;
  flex-wrap: wrap;

  &__label {
    display: inline-flex;
    align-items: center;
    width: auto;
    flex-shrink: 0;
    font-weight: $ds-font-weight-medium;
    margin-right: 1rem;
  }

  &__chips {
    flex-grow: 1;
  }
}
